exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput[type=number][data-v-b8c9f458]::-webkit-inner-spin-button,\ninput[type=number][data-v-b8c9f458]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\ninput[type=number][data-v-b8c9f458] {-moz-appearance: textfield;}\nbutton[data-v-b8c9f458]:focus {\n  outline: none;\n}\n", ""]);

// exports
